var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AmountContainer, AmountDetailsContainer, InnerBarContainer, LegendWrapper, OuterBarContainer } from './subcomponents';
import { Small } from '../../typography';
const ProgressBar = (_a) => {
    var { progress, currentValue, currentLabel, expectedValue, expectedLabel, warnWhenComplete, className } = _a, props = __rest(_a, ["progress", "currentValue", "currentLabel", "expectedValue", "expectedLabel", "warnWhenComplete", "className"]);
    return (React.createElement("div", Object.assign({ className: className }, props),
        React.createElement(OuterBarContainer, { progress: progress },
            React.createElement(InnerBarContainer, { progress: progress, warnWhenComplete: warnWhenComplete })),
        React.createElement(LegendWrapper, null,
            currentValue && (React.createElement(AmountDetailsContainer, null,
                React.createElement(AmountContainer, { weight: "semiBold" }, currentValue),
                React.createElement(Small, null, currentLabel))),
            expectedValue && (React.createElement(AmountDetailsContainer, null,
                React.createElement(AmountContainer, { weight: "semiBold" }, expectedValue),
                React.createElement(Small, null, expectedLabel))))));
};
export default ProgressBar;
